import { render, staticRenderFns } from "./LastFiveGames.vue?vue&type=template&id=db27c97c&scoped=true&"
import script from "./LastFiveGames.vue?vue&type=script&lang=js&"
export * from "./LastFiveGames.vue?vue&type=script&lang=js&"
import style0 from "./LastFiveGames.vue?vue&type=style&index=0&id=db27c97c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db27c97c",
  null
  
)

export default component.exports